"use client";
import "./loadmore.scss";
import { useUpdateSearchParameters } from "@/hooks/useUpdateParameters/useUpdateParameters";
import React, { useState } from "react";

const LoadMore = ({ currentPage }) => {
  const { updateParams, isLoading } = useUpdateSearchParameters();

  const handlePageUpdate = () => {
    updateParams({ key: "page", value: currentPage + 1 });
  };

  return (
    <button onClick={handlePageUpdate} className="load-more cursor-pointer">
      {isLoading ? "Loading..." : "Load More"}
    </button>
  );
};

export default LoadMore;
